<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="container-fluid mt-0">
  <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
  <div class="row">
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="col-1" id="refreshPlatesDiv">
          <button pButton class="refreshPlates" icon="fa fa-refresh" *ngIf="checkMerge()" (click)="getAnnounedPlates()"></button>
        </div>
        <div class="flex justify-content-between px-0">
          <span class="m-0 col-7 px-0">Number Of Plates Matching Filter:
            <span class="m-0 font-weight-bold text-success" style="font-size: 1.2rem;">{{plates == null ? 0: plates.length}}</span>
          </span>
          <span class="col-4 m-0 px-0">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch></span>
        </div>
      </div>
      <div class="col-9">
        <div class="col-12 flex" id="topGroup">

          <div class="col-4 topDivspacing pr-0" id="topDiv">
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
              <input pInputText name="UserPUID" [value]="puid" size="10" id="userID" class="inputFileds" readonly/>
            </div>
            <div class="ui-inputgroup" id="inputClass" value="enabeledd">
              <button pButton class="theme-button noHover labelButton" type="button" label="Plate ID"></button>
              <input pInputText name="SearchPlate" [(ngModel)]="plateToSearch" size="10"
                (keydown.enter)="searchForPlate()" class="inputFileds"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForPlate()"></button>
            </div>
            <div class="ui-inputgroup" id="inputClass" value="enabeledd">
              <button pButton class="theme-button noHover labelButton" type="button" label="Reset Fields" (click)="resetFieldsForMerge()"></button>
            </div>
          </div>

          <div class="col-5 topDivspacing pl-0 pr-0" style="text-align:left;">
            <div class="col-12 flex headers">
              <h5>
                Plate: <strong>{{selectedPlate?.lastUpdatedPlateID}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers statusField">
              <h5>
                Status: <strong> {{selectedPlate?.status}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers">
              <h5>
                Sender: <strong> {{selectedPlate?.sender}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers">
              <h5>
                Sample Type: <strong> {{selectedPlate?.sampleType}} </strong>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="tableLHS1">
          <p-table [value]="plates" [loading]="loading" [(selection)]="tableSelectedRow">
            <ng-template pTemplate="header">
              <tr class="tableBorder">
                <th scope="col" style="width: 35%; border: 1px solid lightgray">Plate ID <span *ngIf="showDueDate"><br/> (Due Date) </span></th>
                <th scope="col" style="width: 65%; border: 1px solid lightgray">Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-plate>
              <tr class="tableBorder">
                <td style="width: 35%; border: 1px solid lightgray" [ngClass]="getPriorityClass(plate?.priority)" class="normalBody text-break pr-0">
                    <span>{{plate?.lastUpdatedPlateID}}</span>
                    <i *ngIf="plate?.latestUserComment" class="pi pi-comment p-1" [pTooltip]="showLatestComment(plate,datePipe)"></i>
                    <i class="pi pi-star-fill" *ngIf="plate?.reRun"></i>
                    <i class="pi pi-arrow-right-arrow-left p-1" *ngIf="checkStatusChange(plate)"></i>
                  <span *ngIf="showDueDate"><br/> ({{ convertUtcToLocal(plate.dueDate) | date : 'dd.MM.yyyy' }}) </span>
                </td>
                <td style="width: 65%; border: 1px solid lightgray" [ngClass]="getPriorityClass(plate?.priority)" class="normalBody pr-0">
                  {{plate?.status}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="col-9">
        <div class="col-12 flex" id="tableDiv">
          <p-confirmDialog class="confirm-message"></p-confirmDialog>
          <table id="batchTable" class="rightTable" aria-describedby="Unboxing Table">
            <tbody id="batchTableBody">
              <p-header>
                <div class="row m-1 p-1" style="width: 83rem;">
                  <div class="col-3 ui-inputgroup inputClass1">
                    <button pButton class="theme-button noHover labelButton1" type="button" label="Merge Type"></button>
                    <p-dropdown name="selectedMergeType" id="selectedMergeType" placeholder="Select Merge Type" [options]="mergeTypeList"
                      [(ngModel)]="selectedMergeType" (onChange)="changeMergeType()"></p-dropdown>
                  </div>
                  <div class="col-3 ui-inputgroup inputClass1">
                    <button pButton class="theme-button noHover labelButton1" type="button" label="Plate-ID 1"></button>
                    <input pInputText [(ngModel)]="scannedPlate1" size="10" id="scannedPlateInput1" (onChange)="inputDirty1=true"
                    (keydown.enter)="addPlateToMerge('1')" class="inputFileds light-green"/>
                  </div>
                  <div class="col-3 ui-inputgroup inputClass1">
                    <button pButton class="theme-button noHover labelButton1" type="button" label="Plate-ID 2"></button>
                    <input pInputText [(ngModel)]="scannedPlate2" size="10" id="scannedPlateInput2" (onChange)="inputDirty2=true"
                    (keydown.enter)="addPlateToMerge('2')" class="inputFileds light-pink"/>
                  </div>
                  <div class="col-3 ui-inputgroup inputClass1">
                    <button pButton class="theme-button noHover labelButton1" type="button" label="Plate-ID 3"></button>
                    <input pInputText [(ngModel)]="scannedPlate3" size="10" id="scannedPlateInput3" (onChange)="inputDirty3=true"
                    (keydown.enter)="addPlateToMerge('3')" class="inputFileds light-blue"/>
                  </div>
                </div>
              </p-header>
              <table id="scanTable" aria-describedby="View Plates" class="table">
                <thead>
                  <tr class="row100 head">
                    <th class="column100 column1" scope="col"></th>
                    <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index">
                      {{col}} </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
                    <td class="column100 column1">{{row}}</td>
                    <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index"
                      style="padding:0% 0.15rem;">
                      <input class="cellviewsold" [style.background]="getSampleAt(i, j).color" pInputText type="text" [value]="getSampleAt(i, j).sampleID" readonly />
                    </td>
                  </tr>
                </tbody>
              </table>
              <p-footer>
                <div class="row m-0" style="padding: 0% 3%;">
                  <div class="col-7">
                  </div>
                  <div class="col-5 p-0" style="display:flex;">
                    <button pButton class="buttonsRound thirdButton" label="Complete Merge" (click)="openCompleteMergePopUp()" style="margin-left: auto;" [disabled]="disableCompleteMergeButton()"></button>
                  </div>
                </div>
              </p-footer>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Merge Plates" [(visible)]="showMergePlatesPopup" showEffect="fade" position="top"
    [modal]="true" [style.width]="'300px'" [contentStyle]="{'max-height':'70vh'}">
    <div class="content-in-multi-update-popup">
      <h6>Scan Barcode</h6>
      <input pInputText name="plateId" [(ngModel)]="selectedPlate.plateID" id="popup-plateid" (keydown.enter)="completeMerge()"/>
      <button pButton label="Complete Merge" (click)="completeMerge()" class="buttonsRound thirdButton mt-3" [disabled]="disableCompleteMergePopUpButton()"></button>
    </div>
</p-dialog>
